import React from 'react';
import { motion } from 'framer-motion';
import instagram from '../../images/instagram-home.svg';
import whatsapp from '../../images/whatsapp-footer-cropped.svg';
import './style.scss';
import { SOCIAL_LINKS } from '../../constants';

const Contact: React.FC = () => {
	const phoneNumber: string = SOCIAL_LINKS.WHATSAPP.PHONE;
	const message: string = SOCIAL_LINKS.WHATSAPP.DEFAULT_MESSAGE;
	const encodedMessage: string = encodeURIComponent(message);
	const whatsappLink: string = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

	const contactSchema = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Ketaren Transport',
		url: 'https://www.ketarenrental.id',
		contactPoint: {
			'@type': 'ContactPoint',
			telephone: SOCIAL_LINKS.WHATSAPP.PHONE,
			contactType: 'Customer Service',
			areaServed: 'ID',
			availableLanguage: 'Indonesian'
		},
		sameAs: [
			'https://www.instagram.com/ketarenrental.id/',
			'https://wa.me/${phoneNumber}?text=${encodedMessage}'
		]
	};

	return (
		<motion.section
			className="contact"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<motion.h2
				initial={{ opacity: 0, y: 20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, delay: 0.2 }}
			>
				Hubungi Kami
			</motion.h2>
			<section className="socials-container">
				<a
					href="https://www.instagram.com/ketarenrental.id/"
					target="_blank"
					className="social-link-container"
					rel="noopener noreferrer"
				>
					<motion.div
						className="social-link social-link--instagram"
						whileHover={{
							scale: 1.05,
							y: -5
						}}
						transition={{
							type: 'spring',
							stiffness: 400,
							damping: 10
						}}
					>
						Instagram
						<img src={instagram} alt="Instagram" />
					</motion.div>
				</a>
				<a
					href={whatsappLink}
					className="social-link-container"
					target="_blank"
					rel="noopener noreferrer"
				>
					<motion.div
						className="social-link social-link--whatsapp"
						whileHover={{
							scale: 1.05,
							y: -5
						}}
						transition={{
							type: 'spring',
							stiffness: 400,
							damping: 10
						}}
					>
						Whatsapp
						<img src={whatsapp} alt="Whatsapp" />
					</motion.div>
				</a>
			</section>
			<motion.div
				className="attributions"
				whileHover={{
					scale: 1.05,
					y: -5
				}}
				transition={{
					type: 'spring',
					stiffness: 400,
					damping: 10
				}}
				onClick={() => {
					const modal = document.createElement('div');
					modal.className = 'attributions-modal';
					modal.style.position = 'fixed';
					modal.style.top = '0';
					modal.style.left = '0';
					modal.style.width = '100%';
					modal.style.height = '100%';

					modal.innerHTML = `
              <div class="attributions-modal-content">
                <p>Images provided thanks to:</p>
                <p>https://unsplash.com/@aabergkvist</p>
                <p>https://unsplash.com/@luke_schober</p>
                <p>https://unsplash.com/@aronvisuals</p>
                <p>https://unsplash.com/@claudiotesta</p>
                <p>https://unsplash.com/@beckenbaauer</p>
                <p>https://unsplash.com/@hyundaimotorgroup</p>
                <p>https://unsplash.com/@robinnoguier</p>
                <p>https://unsplash.com/@bangkoes</p>
                <p>https://unsplash.com/@abdmmar</p>
				<p>https://unsplash.com/@lablineko</p>
				<p>https://unsplash.com/@abdulridwanrr</p>
				<p>https://unsplash.com/@alea_film</p>
				<p>https://unsplash.com/@affanfadhlan</p>
				<p>https://unsplash.com/@visualbywahyu</p>
				<p>https://unsplash.com/@al_fadhly</p>

              </div>
            `;
					modal.addEventListener('click', e => {
						if (e.target === modal) {
							modal.remove();
						}
					});
					const closeButton = modal.querySelector('button');
					if (closeButton) {
						closeButton.addEventListener('click', () => {
							modal.remove();
						});
					}

					document.body.appendChild(modal);
				}}
			>
				<p>Click here to see background image attributions</p>
			</motion.div>

			{/* Adding the schema markup JSON-LD */}
			<script type="application/ld+json">{JSON.stringify(contactSchema)}</script>
		</motion.section>
	);
};

export default Contact;
